import React, { createContext, useContext, useState } from 'react';

const STORAGE_KEY = 'ss_locale';
const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

const isSupportedLocale = (code) =>
  SUPPORTED_LOCALES.some((locale) => locale.code === code);

const LanguageContext = createContext({ locale: 'en', setLanguage: () => {} });

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    const storedLocale = localStorage.getItem(STORAGE_KEY);
    return isSupportedLocale(storedLocale) ? storedLocale : DEFAULT_LOCALE;
  });

  const setLanguage = (newLocale) => {
    const nextLocale = isSupportedLocale(newLocale) ? newLocale : DEFAULT_LOCALE;
    localStorage.setItem(STORAGE_KEY, nextLocale);
    setLocale(nextLocale);
  };

  return (
    <LanguageContext.Provider value={{ locale, setLanguage, SUPPORTED_LOCALES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;
